import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { GET_PRODUCT_INVENTORY_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
import { useIsInAppAuth } from './useUserInfo';
export const useProductInventory = ({
  skip = false
} = {}) => {
  const isInApp = useIsInAppAuth();
  const {
    data,
    loading,
    error
  } = useQuery(GET_PRODUCT_INVENTORY_QUERY, {
    skip: skip || !isInApp
  });
  const productInventory = data === null || data === void 0 ? void 0 : data.result;
  const products = productInventory === null || productInventory === void 0 ? void 0 : productInventory.products;
  const crmSuiteLevel = productInventory === null || productInventory === void 0 ? void 0 : productInventory.crmSuiteLevel;
  return {
    products,
    crmSuiteLevel,
    loading,
    error
  };
};
export const useHasApiNameInProductInventory = ({
  productApiName
}) => {
  const {
    products,
    loading,
    error
  } = useProductInventory();
  const hasProductInInventory = products === null || products === void 0 ? void 0 : products.some(product => product.productApiName === productApiName);
  return {
    hasProductInInventory,
    loading,
    error
  };
};
export const useHasSkuIdInProductInventory = ({
  skuId
}) => {
  const {
    products,
    loading,
    error
  } = useProductInventory();
  const hasSkuIdInInventory = products === null || products === void 0 ? void 0 : products.some(product => product.skuId === skuId);
  return {
    hasSkuIdInInventory,
    loading,
    error
  };
};
export const useIsFreePortal = () => {
  const {
    products,
    loading,
    error
  } = useProductInventory();
  return {
    isFreePortal: (products === null || products === void 0 ? void 0 : products.length) === 0,
    loading,
    error
  };
};
export const useIsPaidPortal = () => {
  const {
    products,
    loading,
    error
  } = useProductInventory();
  return {
    isPaidPortal: !!(products !== null && products !== void 0 && products.length),
    loading,
    error
  };
};
export const useProductFromProductInventoryByApiName = ({
  apiName
}) => {
  const {
    products,
    loading,
    error
  } = useProductInventory({
    skip: !apiName
  });
  const matchingProduct = useMemo(() => {
    return products === null || products === void 0 ? void 0 : products.find(product => product.productApiName === apiName);
  }, [products, apiName]);
  return {
    product: matchingProduct,
    loading,
    error
  };
};
export const useProductFromProductInventoryBySkuId = ({
  skuId
}) => {
  const {
    products,
    loading,
    error
  } = useProductInventory({
    skip: !skuId
  });
  const matchingProduct = useMemo(() => {
    return products === null || products === void 0 ? void 0 : products.find(product => product.skuId === skuId);
  }, [products, skuId]);
  return {
    product: matchingProduct,
    loading,
    error
  };
};
export const useProductInventoryQuantityBySkuId = ({
  skuId
}) => {
  var _product$skuQuantityP;
  const {
    product,
    loading,
    error
  } = useProductFromProductInventoryBySkuId({
    skuId
  });
  return {
    quantity: (_product$skuQuantityP = product === null || product === void 0 ? void 0 : product.skuQuantityPurchased) !== null && _product$skuQuantityP !== void 0 ? _product$skuQuantityP : 0,
    loading,
    error
  };
};
export const useProductInventoryQuantityByApiName = ({
  apiName
}) => {
  var _product$skuQuantityP2;
  const {
    product,
    loading,
    error
  } = useProductFromProductInventoryByApiName({
    apiName
  });
  return {
    quantity: (_product$skuQuantityP2 = product === null || product === void 0 ? void 0 : product.skuQuantityPurchased) !== null && _product$skuQuantityP2 !== void 0 ? _product$skuQuantityP2 : 0,
    loading,
    error
  };
};